import { observable } from "mobx";
import type { EntityValidationRules } from "../services/validationService";
import { Type } from "class-transformer";
import BankAccount from "./bankAccount";

export default class BankAccountBlacklist {
  id: string;
  @Type(() => BankAccount)
  @observable
  bankAccount: BankAccount = new BankAccount();
  description: string;
}

export const BankAccountBlacklistValidationRules: EntityValidationRules<BankAccountBlacklist> = {
  description: {
    required: true,
    isLength: {
      max: 100,
    },
  },
};
